import { useState, type FormEvent } from 'react'
import { Alert, Box, Button, Card, CardContent, CircularProgress, Stack, TextField, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { requestPasswordReset } from '../api/authFlows'
import { errorMessage } from '../api/client'

/** FR-ADM-001k — inițiază resetarea; nu confirmă dacă emailul există, ca să nu scurgă conturi. */
export default function ForgotPasswordPage() {
  const [value, setValue] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await requestPasswordReset(value)
      setSent(true)
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default', p: 2 }}>
      <Card variant="outlined" sx={{ width: '100%', maxWidth: 400 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h3" sx={{ mb: 0.5 }}>Ați uitat parola?</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Introduceți numele de utilizator sau emailul contului.
          </Typography>

          {sent ? (
            <Alert severity="success" variant="outlined">
              Dacă există un cont cu aceste date, veți primi un email cu instrucțiuni de resetare.
            </Alert>
          ) : (
            <form onSubmit={(e) => void submit(e)}>
              <Stack spacing={2}>
                <TextField label="Utilizator sau email" value={value} onChange={(e) => setValue(e.target.value)}
                  autoFocus required fullWidth />
                {error && <Alert severity="error" variant="outlined">{error}</Alert>}
                <Button type="submit" variant="contained" size="large" fullWidth disabled={busy}
                  startIcon={busy ? <CircularProgress size={16} color="inherit" /> : undefined}>
                  Trimite link de resetare
                </Button>
              </Stack>
            </form>
          )}

          <Typography variant="body2" sx={{ mt: 2.5 }}>
            <Link to="/">Înapoi la autentificare</Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}
